/* eslint-disable no-undefined */
import { createTheme as createMuiTheme } from "@mui/material/styles";
import "typeface-work-sans";
import "typeface-roboto";
import { defaultTheme } from "./DefaultTheme";
const getResponsiveTheme = theme => {
  theme.typography.h1 = {
    ...theme.typography.h1,
    [theme.breakpoints.up("md")]: {
      fontSize: "6.375rem",
      //102
      fontWeight: 300,
      letterSpacing: -1.5
    }
  };
  theme.typography.h2 = {
    ...theme.typography.h2,
    [theme.breakpoints.up("md")]: {
      fontSize: "4rem",
      //64
      fontWeight: 300,
      letterSpacing: -0.5
    }
  };
  theme.typography.h3 = {
    ...theme.typography.h3,
    [theme.breakpoints.up("md")]: {
      fontSize: "3rem" //48
    }
  };
  theme.typography.h4 = {
    ...theme.typography.h4,
    [theme.breakpoints.up("md")]: {
      fontSize: "2.125rem" //34
    }
  };
  theme.typography.h5 = {
    ...theme.typography.h5,
    [theme.breakpoints.up("md")]: {
      fontSize: "1.5rem",
      fontWeight: 400,
      letterSpacing: 0
    }
  };
  theme.typography.h6 = {
    ...theme.typography.h6,
    [theme.breakpoints.up("md")]: {
      fontSize: "1.25rem",
      letterSpacing: 0.15
    }
  };
  return theme;
};

/**
 * Create a theme with a value from the platform if available.
 *
 * Fallback to the default built-in theme
 *
 * @param {object} theme
 * @param {object} overrides
 */
export const createTheme = (theme, overrides, typographyOverrides) => {
  let generatedTheme = {};
  if (theme === undefined || theme === null) {
    const newOverrides = {
      ...defaultTheme.components,
      ...overrides
    };
    const newTheme = {
      ...defaultTheme,
      components: newOverrides
    };
    newTheme.typography = {
      ...newTheme.typography,
      ...typographyOverrides
    };
    generatedTheme = getResponsiveTheme(createMuiTheme(newTheme));
  } else {
    const newOverrides = {
      ...theme.components
    };
    const newTheme = {
      ...theme,
      components: newOverrides,
      ...overrides
    };
    generatedTheme = createMuiTheme(newTheme);
  }
  return generatedTheme;
};